import React from 'react';
import animatedScrollTo from 'animated-scrollto';
import classnames from "classnames";

export default class AnimatedScrollLink extends React.Component {
  constructor(props) {
    super(props);
    this.scrollDown = this.scrollDown.bind(this);
  }

  scrollDown() {
    // Guard against running this in server context.
    // I'm not sure how that could happen, but we're being extra defensive.
    if(typeof document === "undefined"){
      return;
    }
 
    setTimeout(window.scrollTo({
      top: this.props.getDomNode().offsetTop
    }), this.props.time || 1000);
    // animatedScrollTo(
    //   // the correct element to scroll is supposed to be the the <html> element
    //   // if the browser is processing the document in standards mode, and the
    //   // body element iff the browser is processing the document in quirks mode.
    //   // We're serving a standards mode document, but, apparently, some browsers
    //   // use quirks mode behavior for the scrollTo property anyway, ig for
    //   // historical consistency. Therefore, the preferred way to detect which
    //   // element should actually be scrolled is to call document.scrollingElement,
    //   // which is a new API introduced solely to abstract all this crazinesss.
    //   // However, document.scrollingElement isn't supported by IE, so we have to
    //   // manually specify document.documentElement (which is the one IE scrolls)
    //   // as the fallback.
    //   document.scrollingElement || document.documentElement, // eslint-disable-line no-undef
    //   this.props.getDomNode().offsetTop,
    //   this.props.time || 1000
    // );
  }

  render() {
    const className = classnames("animated-scroll-link", this.props.className);

    return (
      <a tabIndex="0" onClick={this.scrollDown.bind(this)} className={className}>
        {this.props.children}
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/AnimatedScrollLink/index.js